import { SCREEN_VALUES, type Screen } from '../contexts/AppContext';
import type { WorkspaceAction } from '../services/workspace-assistant.types';

/** Only app routes: no URLs, no automatic form submissions, no model-authored route parameters. */
export function workspaceNavigation(action: WorkspaceAction): { screen: Screen; param?: string; routeParams?: Record<string, string> } | null {
  if (!(SCREEN_VALUES as readonly string[]).includes(action.screen)) return null;
  // Record ids are ObjectIds; a conversation id is its own channel string (letters, digits, - _ : . @ +).
  if (action.param && !(action.screen === 'conversation' ? /^[\w.:@+-]{1,160}$/ : /^[a-f\d]{24}$/i).test(action.param)) return null;
  if (action.settingsItem) {
    if (action.screen !== 'settings' || !['profile', 'notifications', 'developer', 'phone'].includes(action.settingsItem)) return null;
    return { screen: 'settings', routeParams: { settingsItem: action.settingsItem } };
  }
  if (action.screen === 'home' && action.param) return { screen: 'home', routeParams: { assistantContactId: action.param } };
  if (['products-list', 'product-create', 'product-bulk-import'].includes(action.screen) && !action.param) return { screen: action.screen as Screen, param: 'default' };
  return { screen: action.screen as Screen, ...(action.param ? { param: action.param } : {}) };
}
